import clsx from 'clsx';
import React from 'react';

import s from './shared.module.less';

export const MainWithCompactMessengerRow: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div {...rest} className={clsx(s.mainWithCompactMessengerRow, className)}>
    {children}
  </div>
);
